import { Form, Select } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import { FC, useCallback, useMemo } from 'react'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import { useGetStocksQuery } from '../../../../../../../store/api/stocks-api'
import { requiredRules } from '../../../../../../../constants/forms/validation/rules'
import calculateStockAmount from '../../../../../../../helpers/entities/stock/calculate-stock-amount'

interface MaterialActionProps {
    name: NamePath
    rest?: { fieldKey?: number }
    materialTypeDocId: string
    configurationsName: NamePath
    disabled?: boolean
}

const MaterialAction: FC<MaterialActionProps> = ({
    name,
    rest,
    materialTypeDocId,
    configurationsName,
    disabled,
}) => {
    const form = useFormInstance()
    const { data: stocksData } = useGetStocksQuery({
        filters: {
            material: {
                material_type: { documentId: { $eq: materialTypeDocId } },
            },
        },
        populate: '*',
    })

    const materialName = useMemo(
        () => [...configurationsName, name, 'material'],
        [configurationsName, name]
    )
    const amountName = useMemo(
        () => [...configurationsName, name, 'amount'],
        [configurationsName, name]
    )
    const validateReserveAction = useCallback(
        (_rule: unknown, value: string = '') => {
            if (value !== 'Зарезервировать') {
                return Promise.resolve()
            }

            const materialWidth = form.getFieldValue(materialName)
            const amount = form.getFieldValue(amountName)

            if (!materialWidth || !amount) {
                return Promise.resolve()
            }

            const stockItem = stocksData?.data.find(
                item => item.material.documentId === materialWidth
            )

            if (stockItem) {
                const stock = calculateStockAmount(stockItem)

                if (amount > stock) {
                    return Promise.reject(new Error('Превышен остаток'))
                }
            }

            if (!stockItem) {
                return Promise.reject(new Error('Остаток не найден, зарезервировать невозможно'))
            }

            return Promise.resolve()
        },
        [form, materialName, amountName, stocksData]
    )

    return (
        <Form.Item
            name={[name, 'action']}
            label={'Действие'}
            {...rest}
            dependencies={[materialName, amountName]}
            validateTrigger={['onChange', 'onBlur']}
            rules={[...requiredRules, { validator: validateReserveAction }]}
        >
            <Select
                options={[
                    {
                        label: 'Зарезервировать',
                        value: 'Зарезервировать',
                    },
                    {
                        label: 'Заказать',
                        value: 'Заказать',
                    },
                    // TODO: Разрезать не используется, пока не додумана цепочка
                    // {
                    //     label: 'Разрезать',
                    //     value: 'Разрезать',
                    // },
                ]}
                disabled={disabled}
            />
        </Form.Item>
    )
}

export default MaterialAction
